import { defineEvent } from '../types/event';
export var CART_CHECKOUT_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_on_checkout_button - cart'
        }
    ]
});
